<!-- 关于澳门金沙 -->
<template>
    <div class="AboutTenbo">
        <div class="titleBOx">
               <h2 class="title">
               {{help.titel0}}
            </h2>
        </div>
        <div class="content"> 
            <p class="tip2">{{help.titel1}}</p>
            <p class="tip2">{{help.titel2}}</p>
            <h3 class="tip1">{{help.titel3}}</h3>
            <h3 class="tip1">{{help.titel4}}</h3>
            <p class="tip2">{{help.titel5}}</p>
            <p class="tip2">{{help.titel6}}</p>
            <p class="tip2">{{help.titel7}}</p>
            <p class="tip2">{{help.titel8}}</p>
            <p class="tip2">{{help.titel9}}</p>
            <p class="tip2">{{help.titel10}}</p>
            <p class="tip2">{{help.titel11}}</p>
            <h3 class="tip1">{{help.titel12}}</h3>
            <p class="tip2">{{help.titel13}}</p>
            <h3 class="tip1">{{help.titel14}}</h3>
            <p class="tip2">{{help.titel15}}</p>
            <p class="tip2">{{help.titel16}}</p>
            <h3 class="tip1">{{help.titel17}}</h3>
            <p class="tip2">{{help.titel18}}</p>
            <h3 class="tip1">{{help.titel19}}</h3>
            <p class="tip2">{{help.titel20}}</p>
            <h3 class="tip1">{{help.titel21}}</h3>
            <p class="tip2">{{help.titel22}}</p>
            <p class="tip2">{{help.titel23}}</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    computed: {
        help() {
            return this.$t('helpamjs')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .AboutTenbo{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .tip1{
                padding: 0px 0px 20px;
                line-height: 30px;
                font-size: 18px;
                font-weight: 500;
            }
            .tip2{
                line-height: 32px;
                font-size: 14px;
                color: #666;
                text-indent: 2em;
                padding-bottom: 20px;
                .tip3{
                    color: #ec2828;
                }
            }
        }
    }
</style>